import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class PTC_PermissaoAcessoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listaUsuarios() {
    try {
      const { data: { usuarios } } = await this.api.get('ptc/listarusuarios');
      return usuarios;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os Usuários');
    }
  }

  async cadastrarUsuario(data) {
    try {
      await this.api.post('ptc/incluirusuario', data);
    } catch (error) {
      throw this.error.message(error, 'Erro ao cadastrar o Usuário');
    }
  }

  async editarUsuario(id, data) {
    try {
      await this.api.put(`ptc/alterarUsuario/${id}`, data);
    } catch (error) {
      throw this.error.message(error, 'Erro ao editar o Usuário');
    }
  }

  async deletarUsuario(id) {
    try {
      await this.api.delete(`ptc/excluirUsuario/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o Usuário');
    }
  }
}
